import { tryDecodeUri, tryDecodeUriComponent, tryEncodeUriComponent } from "../../../../utilities/EncodeDecode";
import { logger } from "../../../../utilities/logger";
import { ComponentTypes } from "../../config/config";
import { contentManager } from "../../config/constants";
import { getDriveItemByWebUrl } from "../../services/GraphService";

const shareLinkRegex = /\/:[a-zA-Z0-9]{1,2}:\/[a-zA-Z0-9]{1,2}\//;

export const openInHostDocubird: string = "oihost=docubird";

export const isSharePointSharingUrl = (url?: string): boolean => {
    if (!url) return false;

    if (url.includes("guestaccess.aspx")) {
        return true;
    }

    return shareLinkRegex.test(url);
}

export const getGridItemUrl = async (item: any, itemUrl: string, listHttpRoot?: string) => {
    try {
        itemUrl = tryDecodeUriComponent(itemUrl);
        let itemWebUrl = "";
        if (itemUrl?.startsWith("/") && (listHttpRoot || item[".spItemUrl"])) {
            const sharepointDomain = new URL(listHttpRoot ?? item[".spItemUrl"]).origin;
            if (isSharePointSharingUrl(itemUrl)) {
                const driveItem = await getDriveItemByWebUrl(`${sharepointDomain}${itemUrl}`);
                if (driveItem) {
                    const isDocument: boolean = driveItem.file && !driveItem.folder;
                    // const itemUrlResult = new URL(isDocument
                    //     ? await getItemWebViewUrl(await authModule.getGraphAccessToken(), driveItem.driveId, driveItem.id)
                    //     : await getListItemWebUrl(await authModule.getGraphAccessToken(), driveItem.driveId, driveItem.id)
                    // );
                    const itemUrlResult = new URL(isDocument
                        ? driveItem.webUrl
                        : driveItem.listItemWebUrl ?? driveItem.webUrl
                    );

                    if (itemUrlResult) {
                        const decodedHref: string = tryDecodeUri(itemUrlResult.href);
                        if (isDocument) {
                            itemWebUrl = itemUrlResult.href;
                        }
                        else {
                            itemWebUrl = process.env.contentManagerUrl + `?${contentManager.params.preloadURL}=${tryEncodeUriComponent(decodedHref)}`;
                        }
                    }
                } else {
                    itemWebUrl = `${sharepointDomain}${itemUrl}`;
                }
            }

            if (!itemWebUrl) {
                const redirectLocation = `${sharepointDomain}${itemUrl}`;
                const itemExtension: string = redirectLocation.split(".")?.pop()?.trim()?.split("?")?.shift()?.trim();
                if (!itemExtension || itemExtension.length >= 5) {
                    itemWebUrl = process.env.contentManagerUrl + `?${contentManager.params.preloadURL}=${tryEncodeUriComponent(redirectLocation)}`;
                }
                else {
                    itemWebUrl = redirectLocation;
                }
            }
        } else {
            itemWebUrl = itemUrl;
        }
        return itemWebUrl;
    } catch (error) {
        logger(error, "UrlHelper.ts (getGridItemUrl)");
    }
    return itemUrl;
}

export const getItemPathArray = (itemWebUrl: string, isDocubirdManagedLocation: boolean) => {
    if (itemWebUrl) {
        try {
            const url: URL = new URL(itemWebUrl);
            if (url) {
                const fileLocationDetails: string[] = [];
                const isOneDrive: boolean = url.host.endsWith("-my.sharepoint.com");
                let extractedpathArray: string[];
                if (isOneDrive) {
                    fileLocationDetails.push(ComponentTypes.OneDrive);
                    extractedpathArray = url.pathname.split("/");
                    // extractedpathArray?.pop();
                    if (extractedpathArray?.length > 3) {
                        extractedpathArray = extractedpathArray.slice(4);
                    }
                }
                else {
                    fileLocationDetails.push(isDocubirdManagedLocation ? ComponentTypes.Docubird : ComponentTypes.SharePoint);
                    extractedpathArray = url.pathname?.replace("/sites/", "").split("/");
                    // extractedpathArray?.pop();
                }
                extractedpathArray?.forEach(x => fileLocationDetails.push(tryDecodeUriComponent(x)));
                return fileLocationDetails;
            }
        } catch (error) {
            logger(error, "UrlHelper.ts (getItemPath)");
        }
    }
    return null;
}

export const isValidHttpUrl = (url: string): boolean => {
    if (url) {
        try {
            const newUrl = new URL(url);
            return newUrl.protocol === "http:" || newUrl.protocol === "https:";
        } catch (err) {
            // Ignore
        }
    }
    return false;
}

export const tryGetSiteRelativeUrl = (siteUrl: string, itemPath: string) => {
    let siteRelativeUrl: string;
    try {
        let origin = new URL(siteUrl.trim()).origin;
        if (origin.endsWith("/")) {
            origin = origin.slice(0, -1);
        }
        const fullUrl = new URL(origin + itemPath);
        siteRelativeUrl = fullUrl.href.replace(siteUrl, "");
        if (siteRelativeUrl.startsWith("/")) {
            siteRelativeUrl = siteRelativeUrl.slice(1);
        }
    } catch (error) {
        // Ignore
    }
    return siteRelativeUrl ?? "";
}

export const tryGetUrl = (urlString: string): URL | null => {
    if (urlString) {
        try {
            return new URL(urlString);
        } catch (err) {
            // Ignore
        }
    }
    return null;
}